module.exports = __webpack_public_path__ + "img/Assets-13.f0eec564.png";